// extracted by mini-css-extract-plugin
module.exports = {"input":"StyledInput_input__gC7-8"};